import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  selector: 'sd-progress-circle',
  standalone: true,
  templateUrl: './progress-circle.component.html',
  styleUrls: ['./progress-circle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressCircleComponent {
  readonly seconds = input.required<number>();
  readonly initialSeconds = input.required<number>();

  readonly progressPercent = computed(() => {
    const current = this.seconds();
    const max = this.initialSeconds();
    if (max <= 0) return 0;

    return (current / max) * 100;
  });

  readonly circumference = 2 * Math.PI * 20;

  readonly strokeDashoffset = computed(() => {
    const progress = this.progressPercent();

    return this.circumference - (progress / 100) * this.circumference;
  });
}
